/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

const isClassComponent = (component: React.ReactNode): boolean =>
    typeof component === 'function' && !!(component as Function).prototype.isReactComponent;

const isFunctionComponent = (component: React.ReactNode): boolean =>
    typeof component === 'function' && String(component).includes('return React.createElement');

const isReactComponent = (component: React.ReactNode | any): boolean => isClassComponent(component)
    || isFunctionComponent(component)
    || React.isValidElement(component);

const containers: Record<string, Element | null> = {};
const defaultContainerId = 'default1-port-al23-4567-container890';
const getPortalContainer = (containerId?: string): Element | null => {
    const getKitPortalContainer = (): Element => document.querySelector('div[style="position: absolute; top: 0px; left: 0px;"]');
    const currentContainerId = containerId ? containerId : defaultContainerId;

    if (typeof document === 'undefined') {
        return null;
    }

    if (containers[currentContainerId]) {
        return containers[currentContainerId];
    }

    const newPortalDomNode: Element | null = containerId ? document.getElementById(containerId) : getKitPortalContainer();

    if (newPortalDomNode) {
        return containers[currentContainerId] = newPortalDomNode;
    }

    const domNode = document.createElement('div');
    domNode.setAttribute('id', containerId);
    domNode.style.position = 'absolute';
    domNode.style.top = '0px';
    domNode.style.left = '0px';

    document.body.appendChild(domNode);
    containers[containerId] = domNode;

    return containers[containerId];
};

export {
    isReactComponent,
    isClassComponent,
    isFunctionComponent,
    getPortalContainer,
};
